// extracted by mini-css-extract-plugin
export default {"accordion-wrapper":"accordion_accordion-wrapper__8LZDA"};